<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <div class="mt-2">
              <h1 class="text-uppercase font-weight-bold">Crear Proceso</h1>
              <div v-for="(data, index) in processtype" :key="index">
                <b-button
                  class="mt-2"
                  size="lg"
                  block
                  href="#"
                  @click="gotoFormTipoProceso(data.process_option, data.id, data.name)"
                  >{{ data.name }}
                </b-button>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";

numeral.locale("es");

var d = new Date();

export default {
  name: "inicio",
  components: {},
  mounted() {
    this.getTipoProcesos();
  },
  data() {
    return {
      processtype: []
    };
  },
  computed: {},
  methods: {
    gotoFormTipoProceso(process_option, idtipoproceso, tipoprocesotexto) {
      this.$router.push({
        path: "/procesos/" + process_option + "/" + idtipoproceso,
        props: { process_type: idtipoproceso, process_type_name: tipoprocesotexto }
      });
    },
    getTipoProcesos() {
      this.$axios
        .get("/api/v1/processtype/")
        .then((res) => {
          this.processtype = res.data.results;
        })
        .catch((error) => console.log(errors));
    }
  },
  beforeMount() {}
};
</script>
